import { render, staticRenderFns } from "./YzDialogFullscreenContent.vue?vue&type=template&id=209b1802&scoped=true&lang=pug&"
import script from "./YzDialogFullscreenContent.vue?vue&type=script&lang=js&"
export * from "./YzDialogFullscreenContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b1802",
  null
  
)

export default component.exports